import { render } from "./ViewStudentClassRecordDialog.vue?vue&type=template&id=999064aa"
import script from "./ViewStudentClassRecordDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentClassRecordDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__